import React, { useEffect } from "react";
import { AiOutlineClose } from "react-icons/ai";
// import successImage from "../assets/success-image.png"; // Replace with your own image

const SuccessModal = ({ setIsSuccessModalOpen }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsSuccessModalOpen(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, [setIsSuccessModalOpen]);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white w-[90%] max-w-lg rounded-lg shadow-lg p-6 relative animate-fadeIn">
        {/* Close Button */}
        <button
          className="absolute top-4 right-4 text-gray-500 hover:text-red-500 text-2xl"
          onClick={() => setIsSuccessModalOpen(false)}
        >
          <AiOutlineClose />
        </button>

        {/* Image */}
        <div className="flex justify-center">
          {/* <img src={successImage} alt="Success" className="w-32 h-32" /> */}
        </div>

        {/* Message */}
        <h2 className="text-2xl font-bold text-center text-green-600 mt-4">
          Thank You!
        </h2>
        <p className="text-gray-700 text-center mt-2">
          Your Free Consultation is Booked. Our team will reach out shortly to
          schedule your session.
        </p>
        <p className="text-gray-500 text-center text-sm mt-2">
          Keep an eye on your inbox for further details. Need immediate
          assistance? Contact us at{" "}
          <a href="mailto:info@aispry.com" className="text-blue-500 underline">
            info@aispry.com
          </a>
          .
        </p>

        {/* Animated Close Message */}
        <p className="text-center text-sm text-gray-400 mt-4 animate-pulse">
          Closing in 5 seconds...
        </p>
      </div>
    </div>
  );
};

export default SuccessModal;
